import {
	IModel,
	IVIPEventBase,
	VIPEventBase,
} from "@/loader";
import dayjs from "dayjs";
import { Duration } from "dayjs/plugin/duration";

/**
 * Event Interface.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		0.0.0
 * @since		1.0.0
 */
export interface IVIPEvent extends IVIPEventBase {
}

/**
 * Event Class.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		0.0.0
 * @since		1.0.0
 */
export class VIPEvent extends VIPEventBase implements IVIPEvent, IModel<IVIPEvent> {
	constructor (data: IVIPEvent = {}) {
		super(data);
	}

	public load(data: IVIPEvent) {
		super.load(data);
	}

	public update(data: IVIPEvent) {
		super.update(data);
	}

	public get ago(): Duration | null {
		return this.date ? dayjs.duration(this.date.diff(dayjs())) : null;
	}
}
